// extracted by mini-css-extract-plugin
module.exports = {"main":"Organizer_main__bFmVu","name":"Organizer_name__ymrXX","logo":"Organizer_logo__m3ALk"};